<div class="select-wrapper" *ngIf="currentConfig">
	<select (change)="onChangeConfig($event.target.value)" class="select-dropdown professional-select bg-transparent forced">
		<option *ngFor="let configItem of availableConfigs" [value]="configItem.config" [selected]="currentConfig === configItem.config">
			{{ configItem.customerName }} ({{ configItem.allowedAccessLevel }})
		</option>
	</select>

</div>